module.exports = __webpack_public_path__ + "img/hazmat.657871c2.svg";